import Footer from "./Footer";
import { useEffect, useState } from "react";
import { handleShareSecurePoint, pipGetProfile } from "../utils/pip";
import { webPaths } from "../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import LogoutModal from "../components/modal/LogoutModal";
import { useLocation, useNavigate } from "react-router-dom";
import { toggleChange } from "../redux/reducers/authReducer";
import MobileAppModal from "../components/modal/MobileAppModal";
import { AssetsSvg, HomeSvg, MessageSvg } from "../components/svg";
import { fetchProfile } from "../redux/actions/authAction";
import CategoryDropdown from "../components/CategoryDropdown";

const PanelLayout = ({
  children,
  categoryId = "",
  searchFilter = "",
  assetCategoryList = [],
  onCategoryChange,
  onSearchChange,
  onSearch,
  onClearSearch,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const profileData = pipGetProfile();
  const [scroll, setScroll] = useState(false);

  const { isToggle } = useSelector((state) => state.authReducer);
  const searchBarRoutes = [
    webPaths?.AllAssets,
    webPaths?.Home,
    webPaths?.MyAssets,
  ];
  const listItem = [
    {
      label: "Home",
      svg: <HomeSvg />,
      path: webPaths?.Home,
    },
    {
      label: "My Assets",
      svg: <AssetsSvg />,
      path: webPaths?.MyAssets,
    },
    {
      label: "Messages",
      svg: <MessageSvg />,
      isModal: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchProfile())
    const handleScroll = () => {
      setScroll(window.scrollY > 390);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(toggleChange(false));
    };
  }, []);

  console.log({ isToggle });

  return (
    <>
      <header
        class={`ct_header ${scroll && searchBarRoutes?.includes(pathname) ? "ct_active_sticky" : ""}`}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <nav class={`ct_navbar ${isToggle ? "ct_show" : ""}`}>
                <div className="d-flex align-items-center gap-3">
                  <div
                    class="ct_menu_bar ct_cursor_pointer"
                    onClick={() => dispatch(toggleChange(!isToggle))}
                  >
                    <i class="fa-solid fa-bars-staggered"></i>
                  </div>
                  <div class="ct_logo">
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(webPaths?.Home);
                      }}
                    >
                      <img src="/assets/img/logo_black.png" alt="" />
                    </a>
                  </div>
                </div>

                <div className="ct_search_sticky_main">
                  <CategoryDropdown
                    value={categoryId}
                    options={assetCategoryList}
                    onChange={onCategoryChange}
                    className="ct_select_w_177 ct_w_100_575"
                    buttonClassName="ct_input opacity-75"
                    style={{
                      boxShadow: "0px 0px 9px 0px #00000040",
                      height: "50px",
                    }}
                  />
                  <div class="position-relative ct_search">
                    <input
                      type="text"
                      value={searchFilter}
                      onChange={(e) => onSearchChange?.(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          onSearch?.();
                        }
                      }}
                      class="form-control ct_input"
                      style={{
                        boxShadow: "0px 0px 9px 0px #00000040",
                        height: "60px",
                        paddingRight: "90px",
                      }}
                      placeholder="Search assets"
                    />
                    {/* <i class="fa-solid fa-search ct_input_icon_left"></i> */}
                    <button
                      type="button"
                      className="text-white border-0 rounded bg-danger ct_show_eye px-3 py-2"
                      style={{ right: "10px" }}
                      onClick={() => {
                        onClearSearch?.();
                        onSearchChange?.("");
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <ul class="ct_nav_bar_menu">
                  {/* <div class="ct_close_menu ct_cursor_pointer "  onClick={() => dispatch(toggleChange(false))}>
                    <i class="fa-solid fa-xmark"></i>
                  </div> */}
                  {listItem.map((item) => (
                    <li>
                      <a
                        onClick={(e) => {
                          if (item?.label !== "Messages") {
                            e.preventDefault();
                            navigate(item?.path);
                          }
                        }}
                        class={`${pathname == item?.path ? "active" : ""} ct_cursor_pointer`}
                        {...(item?.isModal && {
                          "data-bs-target": "#mobileAppModal",
                          "data-bs-toggle": "modal",
                        })}
                      >
                        {item?.svg}
                        {item?.label}
                      </a>
                    </li>
                  ))}
                </ul>

                <div class="ct_right_menu_login">
                  <div
                    className="ct_cursor_pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#mobileAppModal"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.02718 20.6606L8.6505 20.012V20.012L9.02718 20.6606ZM8.28334 20.0979L7.53901 20.0059V20.0059L8.28334 20.0979ZM7.69451 16.9505L7.03949 17.3159L7.04403 17.3238L7.69451 16.9505ZM6.80557 15.3571L7.46059 14.9917L7.45605 14.9838L6.80557 15.3571ZM20.7936 13.8266L21.1703 14.4752H21.1703L20.7936 13.8266ZM20.6926 12.9076L20.9998 12.2234L20.9998 12.2234L20.6926 12.9076ZM18.3045 10.7882L17.6493 11.1532L17.654 11.1616L18.3045 10.7882ZM17.4606 9.27323L18.1158 8.90822L18.1111 8.8999L17.4606 9.27323ZM9.01683 6.97555L9.39351 7.6241L9.01683 6.97555ZM14.5949 20.5863L14.9716 21.2349L14.5949 20.5863ZM2.31834 11.6339C2.37675 12.044 2.75654 12.3291 3.16661 12.2707C3.57669 12.2122 3.86176 11.8325 3.80335 11.4224L3.06084 11.5281L2.31834 11.6339ZM4.45888 8.1054C4.67554 7.75237 4.56498 7.29054 4.21194 7.07389C3.8589 6.85724 3.39708 6.9678 3.18043 7.32084L3.81966 7.71312L4.45888 8.1054ZM11.9341 2.25123C11.52 2.25908 11.1906 2.60118 11.1985 3.01532C11.2063 3.42946 11.5484 3.75881 11.9626 3.75096L11.9484 3.00109L11.9341 2.25123ZM15.1484 4.80817C15.4706 5.06848 15.9428 5.01829 16.2031 4.69609C16.4634 4.37388 16.4133 3.90167 16.091 3.64137L15.6197 4.22477L15.1484 4.80817ZM8.28334 20.0979L9.02767 20.1899C9.15091 19.1933 9.07548 17.85 8.34499 16.5772L7.69451 16.9505L7.04403 17.3238C7.56695 18.235 7.6354 19.2263 7.53901 20.0059L8.28334 20.0979ZM7.69451 16.9505L8.34948 16.5851L7.46054 14.9917L6.80557 15.3571L6.1506 15.7225L7.03954 17.3159L7.69451 16.9505ZM20.6926 12.9076L20.9998 12.2234C20.3 11.9091 19.4865 11.341 18.955 10.4149L18.3045 10.7882L17.654 11.1616C18.3846 12.4345 19.4836 13.1868 20.3853 13.5917L20.6926 12.9076ZM18.3045 10.7882L18.9597 10.4233L18.1158 8.90825L17.4606 9.27323L16.8054 9.63821L17.6493 11.1532L18.3045 10.7882ZM17.4606 9.27323L18.1111 8.8999C16.1948 5.56105 11.9557 4.40134 8.64016 6.327L9.01683 6.97555L9.39351 7.6241C11.9806 6.12155 15.3022 7.01925 16.8101 9.64656L17.4606 9.27323ZM20.7936 13.8266L21.1703 14.4752C21.6747 14.1822 21.7863 13.6414 21.7398 13.2628C21.6934 12.8849 21.4696 12.4344 20.9998 12.2234L20.6926 12.9076L20.3853 13.5917C20.322 13.5633 20.2872 13.523 20.2719 13.4995C20.2574 13.4772 20.2527 13.4596 20.251 13.4455C20.2493 13.4322 20.2475 13.3979 20.2671 13.3484C20.2891 13.2931 20.3369 13.2245 20.4169 13.1781L20.7936 13.8266ZM6.80557 15.3571L7.45605 14.9838C5.97157 12.3972 6.84662 9.10333 9.39351 7.6241L9.01683 6.97555L8.64016 6.327C5.37015 8.22622 4.26516 12.4374 6.15509 15.7304L6.80557 15.3571ZM9.02718 20.6606L8.6505 20.012C8.73261 19.9643 8.81876 19.957 8.8799 19.9665C8.9342 19.9749 8.96322 19.9946 8.97334 20.0025C8.98414 20.0109 8.99636 20.0234 9.0076 20.0465C9.01958 20.0712 9.03615 20.1214 9.02767 20.1899L8.28334 20.0979L7.53901 20.0059C7.47507 20.523 7.75008 20.9517 8.0534 21.1873C8.35688 21.4229 8.88904 21.6081 9.40385 21.3091L9.02718 20.6606ZM20.7936 13.8266L20.4169 13.1781L8.6505 20.012L9.02718 20.6606L9.40385 21.3091L21.1703 14.4752L20.7936 13.8266ZM15.7475 16.7574L15.0971 17.1307C15.6216 18.0446 15.2869 19.3171 14.2183 19.9378L14.5949 20.5863L14.9716 21.2349C16.6783 20.2436 17.3757 18.0876 16.398 16.3841L15.7475 16.7574ZM14.5949 20.5863L14.2183 19.9378C13.1516 20.5573 11.8956 20.2134 11.3729 19.3027L10.7224 19.676L10.0719 20.0493C11.0514 21.756 13.263 22.2272 14.9716 21.2349L14.5949 20.5863ZM9.72479 4.31763L9.07431 4.69096C9.40403 5.26546 9.20658 5.99803 8.64016 6.327L9.01683 6.97555L9.39351 7.6241C10.6773 6.87848 11.1138 5.23107 10.3753 3.94431L9.72479 4.31763ZM9.01683 6.97555L8.64016 6.327C8.07638 6.65445 7.35341 6.46195 7.02518 5.89004L6.3747 6.26337L5.72422 6.63669C6.4642 7.92604 8.10709 8.37126 9.39351 7.6241L9.01683 6.97555ZM6.3747 6.26337L7.02518 5.89004C6.69547 5.31554 6.89292 4.58297 7.45934 4.254L7.08266 3.60545L6.70598 2.9569C5.4222 3.70252 4.98572 5.34993 5.72422 6.63669L6.3747 6.26337ZM7.08266 3.60545L7.45934 4.254C8.02311 3.92655 8.74608 4.11905 9.07431 4.69096L9.72479 4.31763L10.3753 3.94431C9.63529 2.65496 7.99241 2.20974 6.70598 2.9569L7.08266 3.60545ZM3.06084 11.5281L3.80335 11.4224C3.63701 10.2547 3.86047 9.08052 4.45888 8.1054L3.81966 7.71312L3.18043 7.32084C2.3869 8.61388 2.10615 10.1443 2.31834 11.6339L3.06084 11.5281ZM11.9484 3.00109L11.9626 3.75096C13.1367 3.72868 14.2652 4.09466 15.1484 4.80817L15.6197 4.22477L16.091 3.64137C14.9143 2.69069 13.4356 2.22274 11.9341 2.25123L11.9484 3.00109Z"
                        fill="#121212"
                      />
                    </svg>
                  </div>

                  <div class="ct_right_dropdown dropdown">
                    <button
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src={
                            profileData?.avatar_url ||
                            "/assets/img/user_profile.png"
                          }
                          alt=""
                          class="ct_img_30"
                        />
                      </div>
                      <i class="fa-solid fa-angle-down ms-auto"></i>
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#mobileAppModal"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="18"
                              height="18"
                              rx="2"
                              fill="#4F4F4F"
                            />
                            <path
                              d="M8.47905 14V5H10.521V14H8.47905ZM5 10.521V8.47905H14V10.521H5Z"
                              fill="white"
                            />
                          </svg>
                          Add Assets
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          // onClick={(e) => {
                          //   e.preventDefault();
                          //   navigate(webPaths?.SavedAsset);
                          // }}
                          data-bs-toggle="modal"
                          data-bs-target="#mobileAppModal"
                        >
                          <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V18L7.5 13.9091L0 18V2Z"
                              fill="#4F4F4F"
                            />
                          </svg>
                          Saved Assets
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(webPaths?.AccountSetting);
                          }}
                        >
                          <svg
                            width="22"
                            height="23"
                            viewBox="0 0 22 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.875 7.33695C10.1068 7.33695 9.35578 7.56645 8.71702 7.99642C8.07825 8.42639 7.5804 9.03753 7.28641 9.75254C6.99241 10.4676 6.91549 11.2543 7.06537 12.0134C7.21524 12.7725 7.58518 13.4697 8.12841 14.0169C8.67163 14.5642 9.36374 14.9369 10.1172 15.0879C10.8707 15.2388 11.6517 15.1613 12.3614 14.8652C13.0712 14.569 13.6778 14.0675 14.1046 13.424C14.5315 12.7805 14.7593 12.0239 14.7593 11.25C14.7562 10.2131 14.346 9.21965 13.6182 8.48648C12.8904 7.75331 11.9042 7.34005 10.875 7.33695ZM19.2611 11.25C19.2591 11.6156 19.2325 11.9807 19.1815 12.3427L21.5456 14.2073C21.6485 14.2929 21.7179 14.4127 21.7413 14.5451C21.7647 14.6775 21.7406 14.814 21.6733 14.9302L19.4369 18.8198C19.3689 18.9349 19.2628 19.0222 19.1372 19.0663C19.0116 19.1104 18.8747 19.1085 18.7503 19.0609L15.9707 17.9359C15.3919 18.3849 14.7584 18.7576 14.0858 19.0448L13.6702 22.0177C13.6469 22.1509 13.5785 22.2718 13.4766 22.3597C13.3746 22.4477 13.2456 22.4973 13.1114 22.5H8.63863C8.50688 22.4974 8.37989 22.4499 8.27839 22.3653C8.1769 22.2806 8.10688 22.1638 8.07978 22.0339L7.66417 19.0609C6.9897 18.777 6.35583 18.4038 5.77933 17.9511L2.99965 19.0761C2.8754 19.1237 2.73845 19.1257 2.61288 19.0817C2.48731 19.0377 2.38117 18.9505 2.31311 18.8354L0.0767428 14.9464C0.00942742 14.8302 -0.0146886 14.6937 0.00870417 14.5612C0.032097 14.4288 0.101474 14.3091 0.204438 14.2234L2.5685 12.3589C2.51807 11.9914 2.49148 11.621 2.48887 11.25C2.49089 10.8844 2.51749 10.5193 2.5685 10.1573L0.204438 8.29272C0.101474 8.20707 0.032097 8.08733 0.00870417 7.95489C-0.0146886 7.82245 0.00942742 7.68595 0.0767428 7.56978L2.31311 3.68022C2.38109 3.56507 2.4872 3.47777 2.61278 3.43366C2.73835 3.38956 2.87534 3.39147 2.99965 3.43908L5.77933 4.56407C6.35814 4.11506 6.99155 3.74242 7.66417 3.45522L8.07978 0.482283C8.10304 0.349116 8.17149 0.228221 8.27342 0.140255C8.37535 0.0522898 8.50444 0.00271406 8.63863 0H13.1114C13.2431 0.00258336 13.3701 0.0500827 13.4716 0.134744C13.5731 0.219405 13.6431 0.336228 13.6702 0.466141L14.0858 3.43908C14.7611 3.72276 15.3958 4.096 15.9731 4.54891L18.7503 3.42391C18.8746 3.37627 19.0115 3.37428 19.1371 3.41829C19.2627 3.46231 19.3688 3.54951 19.4369 3.66456L21.6733 7.55413C21.7406 7.6703 21.7647 7.8068 21.7413 7.93924C21.7179 8.07167 21.6485 8.19142 21.5456 8.27706L19.1815 10.1416C19.2319 10.509 19.2585 10.8792 19.2611 11.25Z"
                              fill="#4F4F4F"
                            />
                          </svg>
                          Account Setting
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(webPaths?.HelpSupport);
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM9.991 14C9.72578 14 9.47143 14.1054 9.28389 14.2929C9.09636 14.4804 8.991 14.7348 8.991 15C8.991 15.2652 9.09636 15.5196 9.28389 15.7071C9.47143 15.8946 9.72578 16 9.991 16H10C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15C11 14.7348 10.8946 14.4804 10.7071 14.2929C10.5196 14.1054 10.2652 14 10 14H9.991ZM12.711 5.67C11.781 4.084 9.777 3.51 8.159 4.459L8.144 4.469C7.178 5.059 6.5 6.104 6.5 7.34C6.5 7.60522 6.60536 7.85957 6.79289 8.04711C6.98043 8.23464 7.23478 8.34 7.5 8.34C7.76522 8.34 8.01957 8.23464 8.20711 8.04711C8.39464 7.85957 8.5 7.60522 8.5 7.34C8.5 6.87 8.753 6.441 9.183 6.177C9.814 5.815 10.598 6.02 10.985 6.681C11.356 7.313 11.155 8.102 10.493 8.493C9.9868 8.78549 9.56652 9.2061 9.27442 9.71253C8.98232 10.219 8.8287 10.7934 8.829 11.378V12C8.829 12.2652 8.93436 12.5196 9.12189 12.7071C9.30943 12.8946 9.56378 13 9.829 13C10.0942 13 10.3486 12.8946 10.5361 12.7071C10.7236 12.5196 10.829 12.2652 10.829 12V11.379C10.829 10.912 11.073 10.469 11.495 10.226L11.5 10.223C13.086 9.293 13.66 7.289 12.71 5.671"
                              fill="#4F4F4F"
                            />
                          </svg>
                          Help & Support
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          // onClick={(e) => {
                          //   e.preventDefault();
                          //   navigate(webPaths?.GetSecurPoint);
                          // }}
                            data-bs-toggle="modal"
                          data-bs-target="#mobileAppModal"
                        >
                          <svg
                            width="18"
                            height="22"
                            viewBox="0 0 18 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M8.298 0.126819C8.69262 -0.0208285 9.12379 -0.040077 9.53 0.0718194L9.702 0.126819L16.702 2.75182C17.0569 2.88491 17.3667 3.11612 17.5953 3.41852C17.8239 3.72092 17.9618 4.08205 17.993 4.45982L18 4.62482V9.98782C18 11.6082 17.5624 13.1986 16.7336 14.591C15.9048 15.9834 14.7154 17.1262 13.291 17.8988L13.025 18.0378L9.671 19.7148C9.48632 19.807 9.28461 19.8601 9.07847 19.8708C8.87233 19.8815 8.66621 19.8495 8.473 19.7768L8.329 19.7148L4.975 18.0378C3.52561 17.3131 2.29878 16.2105 1.424 14.8464C0.549233 13.4824 0.0589805 11.9074 0.00500011 10.2878L0 9.98782V4.62482C5.81505e-06 4.24595 0.107627 3.87487 0.310334 3.55479C0.513041 3.23471 0.802495 2.97879 1.145 2.81682L1.298 2.75182L8.298 0.126819ZM12.433 6.56082L7.835 11.1588L6.067 9.39082C5.87936 9.20331 5.62492 9.09802 5.35965 9.09812C5.09438 9.09821 4.84001 9.20368 4.6525 9.39132C4.46499 9.57896 4.3597 9.8334 4.3598 10.0987C4.35989 10.3639 4.46536 10.6183 4.653 10.8058L7.057 13.2098C7.15915 13.312 7.28044 13.3931 7.41393 13.4484C7.54742 13.5037 7.6905 13.5322 7.835 13.5322C7.9795 13.5322 8.12258 13.5037 8.25607 13.4484C8.38956 13.3931 8.51085 13.312 8.613 13.2098L13.847 7.97482C13.9425 7.88257 14.0187 7.77223 14.0711 7.65022C14.1235 7.52822 14.1511 7.397 14.1523 7.26422C14.1534 7.13144 14.1281 6.99976 14.0778 6.87687C14.0275 6.75397 13.9533 6.64232 13.8594 6.54842C13.7655 6.45453 13.6539 6.38028 13.531 6.33C13.4081 6.27972 13.2764 6.25442 13.1436 6.25557C13.0108 6.25672 12.8796 6.28431 12.7576 6.33672C12.6356 6.38913 12.5252 6.46531 12.433 6.56082Z"
                              fill="#4F4F4F"
                            />
                          </svg>
                          Get SecurPoint
                          <i class="fa-solid fa-plus ct_fs_14"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          onClick={()=>handleShareSecurePoint()}
                       
                        >
                          <svg
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.3452 12.7228C12.6993 12.7257 12.0778 12.9738 11.6027 13.4186L5.2636 9.6685C5.31262 9.4612 5.33944 9.24912 5.34361 9.03596C5.33944 8.8228 5.31262 8.61072 5.2636 8.40342L11.5315 4.68948C11.9803 5.11163 12.5584 5.36381 13.1686 5.4036C13.7788 5.44339 14.3839 5.26837 14.8821 4.90798C15.3803 4.54759 15.7411 4.02381 15.9039 3.42477C16.0667 2.82572 16.0216 2.18795 15.7761 1.61875C15.5306 1.04955 15.0998 0.583652 14.556 0.299421C14.0122 0.0151913 13.3887 -0.0700238 12.7904 0.0581112C12.192 0.186246 11.6554 0.519913 11.2707 1.00298C10.886 1.48605 10.6767 2.08904 10.678 2.71053C10.6822 2.92369 10.709 3.13577 10.758 3.34307L4.49011 7.057C4.11047 6.69576 3.63521 6.45519 3.12281 6.3649C2.6104 6.27461 2.08321 6.33855 1.60609 6.54883C1.12897 6.75912 0.722738 7.10658 0.437384 7.54847C0.15203 7.99036 0 8.50739 0 9.03596C0 9.56453 0.15203 10.0816 0.437384 10.5235C0.722738 10.9653 1.12897 11.3128 1.60609 11.5231C2.08321 11.7334 2.6104 11.7973 3.12281 11.707C3.63521 11.6167 4.11047 11.3762 4.49011 11.0149L10.8203 14.774C10.7742 14.9663 10.7503 15.1635 10.7492 15.3614C10.7492 15.8833 10.9014 16.3934 11.1867 16.8273C11.4719 17.2612 11.8774 17.5994 12.3518 17.7991C12.8261 17.9989 13.3481 18.0511 13.8517 17.9493C14.3553 17.8475 14.8179 17.5962 15.181 17.2272C15.544 16.8582 15.7913 16.388 15.8914 15.8762C15.9916 15.3643 15.9402 14.8338 15.7437 14.3516C15.5472 13.8695 15.2145 13.4574 14.7875 13.1675C14.3606 12.8775 13.8587 12.7228 13.3452 12.7228Z"
                              fill="#32CD30"
                            />
                          </svg>
                          Share SecurPoint
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          data-bs-toggle="modal"
                          data-bs-target="#logoutModal"
                        >
                          <svg
                            width="24"
                            height="21"
                            viewBox="0 0 24 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.2267 0.000976562C15.5221 0.000976562 15.8055 0.118477 16.0144 0.327393C16.2233 0.536308 16.3407 0.819538 16.3407 1.11499L16.3407 5.57007C16.3407 5.86561 16.2234 6.14908 16.0145 6.35815C15.8056 6.56723 15.5222 6.68479 15.2267 6.68506C15.0803 6.68506 14.9354 6.65614 14.8001 6.6001C14.6649 6.54405 14.5421 6.46195 14.4386 6.3584C14.3352 6.25485 14.2531 6.13185 14.1972 5.99658C14.1413 5.86131 14.1126 5.71644 14.1127 5.57007V2.229L2.22669 2.229L2.22669 17.823L14.1077 17.823V14.481C14.1076 14.3346 14.1363 14.1899 14.1922 14.0547C14.2482 13.9195 14.3302 13.7966 14.4337 13.6931C14.5371 13.5896 14.66 13.5076 14.7952 13.4517C14.9304 13.3957 15.0754 13.3671 15.2217 13.3672C15.5171 13.3672 15.8005 13.4844 16.0094 13.6934C16.2183 13.9023 16.3357 14.1855 16.3357 14.481V18.936C16.3354 19.2314 16.218 19.5145 16.0091 19.7234C15.8003 19.9322 15.5171 20.0498 15.2217 20.05L1.11369 20.05C0.818237 20.05 0.534883 19.9328 0.325968 19.7239C0.117052 19.515 -0.000310898 19.2315 -0.000310898 18.936L-0.000310898 1.11401C-0.000310898 0.818562 0.117052 0.535332 0.325968 0.326416C0.534883 0.1175 0.818237 0 1.11369 0L15.2267 0.000976562ZM20.0987 5.90112L23.4407 9.24316C23.4657 9.26816 23.4897 9.29404 23.5117 9.32104C23.5337 9.34805 23.5317 9.34908 23.5417 9.36108C23.5517 9.37308 23.5657 9.39218 23.5767 9.40918C23.5877 9.42618 23.5967 9.44101 23.6057 9.45801C23.6147 9.47501 23.6237 9.48817 23.6327 9.50317C23.6417 9.51817 23.6487 9.53695 23.6577 9.55396C23.6667 9.57096 23.6737 9.58603 23.6797 9.60303C23.6857 9.62003 23.6917 9.63608 23.6977 9.65308C23.7037 9.67008 23.7107 9.68806 23.7157 9.70605C23.721 9.72279 23.7253 9.73984 23.7287 9.75708C23.7287 9.77508 23.7387 9.79301 23.7427 9.81201C23.7467 9.83101 23.7487 9.85109 23.7517 9.87109C23.7547 9.89109 23.7577 9.90417 23.7577 9.92017C23.7612 9.95639 23.7628 9.99266 23.7627 10.0291C23.7629 10.0651 23.7612 10.1011 23.7577 10.137C23.7577 10.155 23.7577 10.17 23.7517 10.188C23.7457 10.206 23.7467 10.2261 23.7427 10.2461C23.7387 10.2661 23.7337 10.283 23.7287 10.302C23.7252 10.3189 23.7209 10.3356 23.7157 10.3521C23.7097 10.3701 23.7037 10.388 23.6977 10.406C23.6917 10.424 23.6857 10.4391 23.6797 10.4551C23.6737 10.4711 23.6647 10.4881 23.6567 10.5051C23.6487 10.5221 23.6417 10.5382 23.6327 10.5552C23.6237 10.5722 23.6147 10.5861 23.6057 10.6011C23.5967 10.6161 23.5877 10.6332 23.5777 10.6492C23.5662 10.6661 23.5538 10.6823 23.5407 10.698L23.5127 10.7371C23.4897 10.7659 23.465 10.7933 23.4387 10.8191L20.0977 14.1611C19.8887 14.3697 19.6054 14.4868 19.3102 14.4868C19.0149 14.4868 18.7317 14.3697 18.5227 14.1611C18.3138 13.9521 18.1965 13.6686 18.1965 13.373C18.1965 13.0775 18.3138 12.794 18.5227 12.585L19.9627 11.145L7.06269 11.145C6.76723 11.145 6.48389 11.0278 6.27497 10.8188C6.06606 10.6099 5.94869 10.3265 5.94869 10.031C5.94869 9.73555 6.06606 9.45232 6.27497 9.24341C6.48389 9.03449 6.76723 8.91699 7.06269 8.91699L19.9627 8.91699L18.5227 7.47705C18.3142 7.26802 18.197 6.98472 18.197 6.68945C18.197 6.39419 18.3142 6.11113 18.5227 5.9021C18.626 5.7987 18.7487 5.71658 18.8837 5.66064C19.0188 5.60471 19.1635 5.57612 19.3097 5.57617C19.6039 5.57421 19.8869 5.68876 20.0967 5.89502L20.0987 5.90112Z"
                              fill="#C60000"
                            />
                          </svg>
                          Log Out
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
      {children}
      <Footer />

      <MobileAppModal />
      <LogoutModal />

      <div className="ct_fixed_button_top">
        <button
          class="ct_green_bnt ct_white_nowrap  px-3 ct_border_radius_15 ct_green_btn_after_15_radius"
          data-bs-target="#mobileAppModal"
          data-bs-toggle="modal"
        >
          <i class="fa-solid fa-plus me-2"></i>Add Assets
        </button>
      </div>
    </>
  );
};

export default PanelLayout;
